import { useContext } from "react";
import { applicationContext } from 'helpers/services';
import { Tooltip } from "@mui/material";

interface IProps {
    username: string
    defaultValue?: string
    tooltipPlacement?: "right" | "bottom-end" | "bottom-start" | "bottom" | "left-end" | "left-start" | "left" | "right-end" | "right-start" | "top-end" | "top-start" | "top" | undefined
}

let SimecUser = ({ username, defaultValue, tooltipPlacement }: IProps) => {
    let appService = useContext(applicationContext);

    return (
        <Tooltip title={username || ''} placement={tooltipPlacement}>
            <span>{appService.simecUsers?.find(x => x.email === username)?.fullName || (defaultValue ? defaultValue : username)}</span>
        </Tooltip>
    )
}

export default SimecUser;